import React from 'react';
import  styles from './GoogleDriveVideoPlayer.module.scss';



const GoogleDriveVideoPlayer = ({ videoUrl, googleStyles }: { videoUrl: string, googleStyles?: string }) => {

  function getPreviewLink() {
    if (!videoUrl) return "";

    const match = videoUrl.match(/\/d\/([^/]+)\//);
    const fileId = match ? match[1] : null;

    if (!fileId) return "";

    return `https://drive.google.com/file/d/${fileId}/preview`;
  }

  const previewUrl = getPreviewLink();

  return (
    <div className={`${styles.GoogleDriveVideoPlayer} ${googleStyles ? googleStyles : ''}`}>
      <iframe
        //@ts-ignore
        loading="lazy"
        className={styles.GoogleDriveVideoPlayer__iframe}
        src={previewUrl}
        width="100%"
        height="480"
        style={{ border: "none" }}
        allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
        allowFullScreen
        title="Google Drive Video"
      />
    </div>
  )
}

export default GoogleDriveVideoPlayer